export const LogoMark = ({ className = "w-8 h-8", stroke = "#F2EEE6", accent = "#C9A96E" }) => (
  <svg viewBox="0 0 64 64" className={className} aria-hidden="true">
    <path d="M14 52 L32 12 L50 52" fill="none" stroke={accent} strokeWidth="3.2" />
    <path d="M14 52 V34 a18 18 0 0 1 36 0 V52" fill="none" stroke={stroke} strokeWidth="2" />
    <line x1="22" y1="40" x2="42" y2="40" stroke={accent} strokeWidth="2" />
  </svg>
);

export const Logo = ({ className = "" }) => (
  <span className={`flex items-center gap-3 ${className}`}>
    <LogoMark className="w-8 h-8 md:w-9 md:h-9" />
    <span className="font-display text-base md:text-lg tracking-[0.18em] md:tracking-[0.32em] leading-none whitespace-nowrap">
      ALLURE<span className="text-gold hidden sm:inline"> · </span><span className="sm:hidden"> </span>HOUSE
    </span>
  </span>
);
